"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAgent = void 0;
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
var request_1 = require("../api/request");
var storage_1 = require("../utils/storage");
var UserAgent = /** @class */function () {
  function UserAgent() {
    /** 获取浏览器兼容信息 */
    this.browserCompatibility = {
      supportFetch: request_1.APIs.supportFetch ? 'true' : 'false',
      supportFetchKeepAlive: request_1.APIs.supportFetchKeepAlive ? 'true' : 'false',
      supportSendBeacon: request_1.APIs.supportSendBeacon ? 'true' : 'false',
      supportLocalstorage: storage_1.supportLocalstorage ? 'true' : 'false'
    };
    var parser = new ua_parser_js_1.default();
    this.ua = parser.getResult();
  }
  Object.defineProperty(UserAgent.prototype, "connection", {
    get: function get() {
      var _a, _b, _c, _d, _e;
      if (!navigator.connection) {
        return {
          connection_type: 'unknown'
        };
      }
      return {
        connection_type: ((_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType) || ((_b = navigator.connection) === null || _b === void 0 ? void 0 : _b.type) || 'unknown',
        // to kibibit per second
        connection_downlink: ((_c = navigator.connection) === null || _c === void 0 ? void 0 : _c.downlink) ? ((_d = navigator.connection) === null || _d === void 0 ? void 0 : _d.downlink) * 1024 : -1,
        connection_rtt: (_e = navigator.connection) === null || _e === void 0 ? void 0 : _e.rtt
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UserAgent.prototype, "browser", {
    get: function get() {
      var _a, _b, _c, _d;
      return {
        browser: this.ua.ua,
        browser_name: (_a = this.ua.browser.name) !== null && _a !== void 0 ? _a : '',
        browser_version: (_b = this.ua.browser.version) !== null && _b !== void 0 ? _b : '',
        engine_name: (_c = this.ua.engine.name) !== null && _c !== void 0 ? _c : '',
        engine_version: (_d = this.ua.engine.version) !== null && _d !== void 0 ? _d : ''
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UserAgent.prototype, "screen", {
    get: function get() {
      return {
        screen_dpr: window.devicePixelRatio ? parseFloat(window.devicePixelRatio.toFixed(2)) : undefined,
        screen_height: window.screen.height,
        screen_width: window.screen.width
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UserAgent.prototype, "device", {
    get: function get() {
      var _a, _b, _c;
      return {
        os_name: this.ua.os.name,
        os_version: this.ua.os.version,
        device_name: (_b = (_a = this.ua.device) === null || _a === void 0 ? void 0 : _a.model) !== null && _b !== void 0 ? _b : (_c = this.ua.device) === null || _c === void 0 ? void 0 : _c.type,
        device_id: ''
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UserAgent.prototype, "webData", {
    get: function get() {
      return __assign(__assign(__assign({}, this.browser), this.screen), this.connection);
    },
    enumerable: false,
    configurable: true
  });
  return UserAgent;
}();
exports.UserAgent = UserAgent;